import React from "react";
import "../../App.css";
import BiltyProfitLossFTLWise from "../BiltyProfitLossFTL";

function BiltyProfitAndLossFTL({ sessionObject }) {
  if (
    !sessionObject.sessionVariables["modules"].includes("bilty-pl-report-ftl")
  ) {
    return;
  }
  return (
    <div className="page-inward">
      <BiltyProfitLossFTLWise sessionObject={sessionObject} />
    </div>
  );
}

export default BiltyProfitAndLossFTL;
